import { motion } from 'framer-motion';

const stats = [
  {
    id: 1,
    value: '10,000+',
    label: 'Citizens Protected',
  },
  {
    id: 2,
    value: '6',
    label: 'Pilot States',
  },
  {
    id: 3,
    value: '24/7',
    label: 'Emergency Availability',
  },
  {
    id: 4,
    value: '100%',
    label: 'Accountable Response Tracking',
  },
];

export default function ImpactGoalsSection() {
  return (
    <section className="py-20 sm:py-28 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 text-xs font-bold tracking-widest text-[#16A34A] uppercase bg-[#16A34A]/10 rounded-full mb-3">
            Future Metrics
          </span>
          <h2 className="font-sans text-2xl sm:text-3xl font-bold text-[#0F172A] tracking-tight">
            Our Rollout Targets
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-12 text-center">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="flex flex-col"
            >
              <span className="font-sans text-5xl md:text-6xl font-bold tracking-tighter text-[#0F172A] mb-3">
                {stat.value}
              </span>
              <span className="font-sans text-xs uppercase tracking-widest text-[#0F172A]/60 font-semibold">
                {stat.label}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
